export const radarStories = [
    {
        label: 'Formatting tooltip value',
        link: {
            kind: 'Radar',
            story: 'with formatted values',
        },
    },
    {
        label: 'Custom label component',
        link: {
            kind: 'Radar',
            story: 'custom label component',
        },
    },
]
